import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { EditorContent } from "@tiptap/react";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelBlockFont from "../../lib/panel/panel-block-font";
import PanelContainer from "../../lib/panel/panel-container";
import PanelContent from "../../lib/panel/panel-content";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { useParagraphEditor } from "./email-panel-content";
import { EmailPanelToolbar } from "./email-panel-toolbar";
import { ParagraphBlockProps } from "./types";

function ParagraphPanelContent() {
  const editor = useParagraphEditor();

  return (
    <>
      <PanelContent title="Contenu">
        <div className="space-y-2">
          <EmailPanelToolbar editor={editor} />
          <EditorContent editor={editor} />
        </div>
      </PanelContent>
      <FloatingPanelSeparator />
      <PanelBlockFont />
      <PanelBlockAlignment />
      <PanelTranslationState mode="translatable" portal />
    </>
  );
}

export function ParagraphEmailPanelRenderer(blockProps: ParagraphBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      {/* Remount on locale change so the TipTap editor re-initializes with
          the current locale's content instead of reusing the stale instance. */}
      <ParagraphPanelContent key={blockProps.locale} />
    </PanelContainer>
  );
}
